export default "__VITE_ASSET__B32MCvAc__"